import {TOGGLE_STEPS_LIST, 
    TOGGLE_RESPONSES_LIST, 
    SELECT_RESPONSE, 
    RESET_CONFIGURATION,
    _VAULTFINANCIAL,
    VAULT_RESPURCHASECC_SENT,VAULT_RESPURCHASECC_SUCCESS,VAULT_RESPURCHASECC_FAIL,
    VAULT_RESPREAUTHCC_SENT,VAULT_RESPREAUTHCC_SUCCESS,VAULT_RESPREAUTHCC_FAIL,
    VAULT_RESINDREFUNDCC_SENT,VAULT_RESINDREFUNDCC_SUCCESS,VAULT_RESINDREFUNDCC_FAIL,
    VAULT_RESFORCEPOSTCC_SENT,VAULT_RESFORCEPOSTCC_SUCCESS,VAULT_RESFORCEPOSTCC_FAIL,
    VAULT_CARDVERIFICATION_SENT,VAULT_CARDVERIFICATION_SUCCESS,VAULT_CARDVERIFICATION_FAIL,
    UPDATE_PREV_SUCC_STEP,
} from './types'

const HOST = "https://developer.moneris.com/demoapi"
// "https://developer.moneris.com:8081"
//http://monerisdeveloperauth.monad.moneris.com:8081
//https://localhost:5001

export const toggleStepsList = () => dispatch => {
dispatch({ feature: _VAULTFINANCIAL, type: TOGGLE_STEPS_LIST });
}

export const toggleResponsesList = () => dispatch => {
dispatch({ feature: _VAULTFINANCIAL, type: TOGGLE_RESPONSES_LIST });
}

export const selectResponse = (responseId) => dispatch => {
dispatch({ feature: _VAULTFINANCIAL, type: SELECT_RESPONSE, payload: responseId });
}

export const updatePrevSuccStep = (stepId) => dispatch => {
dispatch({ feature: _VAULTFINANCIAL, type: UPDATE_PREV_SUCC_STEP, payload: stepId });
}

export const resetConfiguration = () => dispatch => {
dispatch({ feature: _VAULTFINANCIAL, type: RESET_CONFIGURATION });
}
export const makeVaultResPurchaseCC = (ResPurchaseRequest) => async dispatch => {
    dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESPURCHASECC_SENT });
    const { storeId, apiToken, order_id, pan, expdate, amount } = ResPurchaseRequest;
    try {
        let response = await fetch(`${HOST}/api/vault/purchase`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })
        let responseJson = await response.json();
        var output = "";
        console.log(responseJson)
        output += "DataKey = " + responseJson.DataKey + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "CardType = " + responseJson.CardType+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "ResSuccess = " + responseJson.ResSuccess+ '\n';
        output += "PaymentType = " + responseJson.PaymentType+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';
        output += "Cust ID = " + responseJson.CustID+ '\n';
        output += "Phone = " + responseJson.Phone+ '\n';
        output += "Email = " + responseJson.Email+ '\n';
        output += "Note = " + responseJson.Note+ '\n';
        output += "MaskedPan = " + responseJson.MaskedPan+ '\n';
        output += "ExpDate = " + responseJson.ExpDate+ '\n';
        output += "CryptType = " + responseJson.CryptType+ '\n';
        output += "AvsStreetNumber = " + responseJson.AvsStreetNumber+ '\n';
        output += "AvsStreetName = " + responseJson.AvsStreetName+ '\n';
        output += "AvsZipcode = " + responseJson.AvsZipcode+ '\n';
        if(responseJson.ResponseCode === '027'){
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESPURCHASECC_SUCCESS, payload: output });
            dispatch({ feature: _VAULTFINANCIAL, type: UPDATE_PREV_SUCC_STEP, payload: 16 });
        }else{
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESPURCHASECC_FAIL, payload: output });
        }
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESPURCHASECC_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeVaultResPreauthCC = (ResPreauthRequest) => async dispatch => {
    dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESPREAUTHCC_SENT });
    const { storeId, apiToken, order_id, pan, expdate, amount } = ResPreauthRequest;
    try {
        let response = await fetch(`${HOST}/api/vault/preauth`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })
        let responseJson = await response.json();
        var output = "";
        console.log(responseJson)
        output += "DataKey = " + responseJson.DataKey + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "CardType = " + responseJson.CardType+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "ResSuccess = " + responseJson.ResSuccess+ '\n';
        output += "PaymentType = " + responseJson.PaymentType+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';
        output += "Cust ID = " + responseJson.CustID+ '\n';
        output += "Phone = " + responseJson.Phone+ '\n';
        output += "Email = " + responseJson.Email+ '\n';
        output += "Note = " + responseJson.Note+ '\n';
        output += "MaskedPan = " + responseJson.MaskedPan+ '\n';
        output += "ExpDate = " + responseJson.ExpDate+ '\n';
        output += "CryptType = " + responseJson.CryptType+ '\n';
        output += "AvsStreetNumber = " + responseJson.AvsStreetNumber+ '\n';
        output += "AvsStreetName = " + responseJson.AvsStreetName+ '\n';
        output += "AvsZipcode = " + responseJson.AvsZipcode+ '\n';
        if(responseJson.ResponseCode === '027'){
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESPREAUTHCC_SUCCESS, payload: output });
            dispatch({ feature: _VAULTFINANCIAL, type: UPDATE_PREV_SUCC_STEP, payload: 17 });
        }else{
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESPREAUTHCC_FAIL, payload: output });
        }
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESPREAUTHCC_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeVaultResIndRefundCC = (ResindRefundRequest) => async dispatch => {
    dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESINDREFUNDCC_SENT });
    const { storeId, apiToken, order_id, pan, expdate, amount } = ResindRefundRequest;
    try {
        let response = await fetch(`${HOST}/api/vault/independentrefund`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })
        let responseJson = await response.json();
        var output = "";
        console.log(responseJson)
        output += "DataKey = " + responseJson.DataKey + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "CardType = " + responseJson.CardType+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "ResSuccess = " + responseJson.ResSuccess+ '\n';
        output += "PaymentType = " + responseJson.PaymentType+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';
        output += "Cust ID = " + responseJson.CustID+ '\n';
        output += "Phone = " + responseJson.Phone+ '\n';
        output += "Email = " + responseJson.Email+ '\n';
        output += "Note = " + responseJson.Note+ '\n';
        output += "MaskedPan = " + responseJson.MaskedPan+ '\n';
        output += "ExpDate = " + responseJson.ExpDate+ '\n';
        output += "CryptType = " + responseJson.CryptType+ '\n';
        output += "AvsStreetNumber = " + responseJson.AvsStreetNumber+ '\n';
        output += "AvsStreetName = " + responseJson.AvsStreetName+ '\n';
        output += "AvsZipcode = " + responseJson.AvsZipcode+ '\n';
        if(responseJson.ResponseCode === '027'){
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESINDREFUNDCC_SUCCESS, payload: output });
            dispatch({ feature: _VAULTFINANCIAL, type: UPDATE_PREV_SUCC_STEP, payload: 18 });
        }else{
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESINDREFUNDCC_FAIL, payload: output });
        }
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESINDREFUNDCC_FAIL, payload: 'Error, please try again.'});
    }
}


// VAULT_CARDVERIFICATION_SENT,VAULT_CARDVERIFICATION_SUCCESS,VAULT_CARDVERIFICATION_FAIL,
export const makeVaultResForcePostCC = (ResForcePostRequest) => async dispatch => {
    dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESFORCEPOSTCC_SENT });
    const { storeId, apiToken, order_id, pan, expdate, amount } = ResForcePostRequest;
    try {
        let response = await fetch(`${HOST}/api/vault/forcepost`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })
        let responseJson = await response.json();
        var output = "";
        console.log(responseJson)
        output += "DataKey = " + responseJson.DataKey + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "CardType = " + responseJson.CardType+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "ResSuccess = " + responseJson.ResSuccess+ '\n';
        output += "PaymentType = " + responseJson.PaymentType+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';
        output += "Cust ID = " + responseJson.CustID+ '\n';
        output += "Phone = " + responseJson.Phone+ '\n';
        output += "Email = " + responseJson.Email+ '\n';
        output += "Note = " + responseJson.Note+ '\n';
        output += "MaskedPan = " + responseJson.MaskedPan+ '\n';
        output += "ExpDate = " + responseJson.ExpDate+ '\n';
        output += "CryptType = " + responseJson.CryptType+ '\n';
        output += "AvsStreetNumber = " + responseJson.AvsStreetNumber+ '\n';
        output += "AvsStreetName = " + responseJson.AvsStreetName+ '\n';
        output += "AvsZipcode = " + responseJson.AvsZipcode+ '\n';
        if(responseJson.ResponseCode === '027'){
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESFORCEPOSTCC_SUCCESS, payload: output });
            dispatch({ feature: _VAULTFINANCIAL, type: UPDATE_PREV_SUCC_STEP, payload: 19 });
        }else{
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESFORCEPOSTCC_FAIL, payload: output });
        }
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _VAULTFINANCIAL, type: VAULT_RESFORCEPOSTCC_FAIL, payload: 'Error, please try again.'});
    }
}



// ,,,
export const makeVaultResCardVerificationCC = (ResCardVerificationRequest) => async dispatch => {
    dispatch({ feature: _VAULTFINANCIAL, type: VAULT_CARDVERIFICATION_SENT });
    const { storeId, apiToken, order_id, pan, expdate, amount } = ResCardVerificationRequest;
    try {
        let response = await fetch(`${HOST}/api/vault/cardverification`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })
        let responseJson = await response.json();
        var output = "";
        console.log(responseJson)
        output += "CardType = " + responseJson.CardType+ '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';
        if(responseJson.ResponseCode === '027'){
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_CARDVERIFICATION_SUCCESS, payload: output });
            dispatch({ feature: _VAULTFINANCIAL, type: UPDATE_PREV_SUCC_STEP, payload: 20 });
        }else{
            dispatch({ feature: _VAULTFINANCIAL, type: VAULT_CARDVERIFICATION_FAIL, payload: output });
        }
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _VAULTFINANCIAL, type: VAULT_CARDVERIFICATION_FAIL, payload: 'Error, please try again.'});
    }
}

    
